import { render, staticRenderFns } from "./SideMenuExpandEditableLink.vue?vue&type=template&id=4c700e1c&scoped=true"
import script from "./SideMenuExpandEditableLink.vue?vue&type=script&lang=ts"
export * from "./SideMenuExpandEditableLink.vue?vue&type=script&lang=ts"
import style0 from "./SideMenuExpandEditableLink.vue?vue&type=style&index=0&id=4c700e1c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c700e1c",
  null
  
)

export default component.exports